import { useDispatch } from "react-redux";
import { fetchTypesWithFallback } from "../features/cache/fetchTypes";

const useTypes = () => {
  const dispatch = useDispatch();
  const fetchTypes = (controller, scope) => {
    if (controller && scope)
      dispatch(fetchTypesWithFallback(controller, scope));
  };
  return { fetchTypes };
};

export default useTypes;
